
import { TechpackRowItem } from '@/store/modules/techpacks/techpacks.model'
import { defineComponent } from 'vue'
import formatDate from '../utils/format-date'

export default defineComponent({
  name: 'TechpacksList',
  props: {
    techpacks: {
      type: Array as () => Array<TechpackRowItem>
    },
    loading: Boolean
  },
  computed: {
    hasTechpacks(): boolean {
      const len = this.techpacks?.length || 0
      return len > 0
    }
  },
  methods: {
    formatDate
  }
})
